/*
 * View for the list of tasks belonging to a topic
 */

define(["marionette", "messaging/messenger", "./template/tasksListItemTemplate.html"], function (
  Marionette,
  Messenger,
  TasksListItemTemplate,
) {
  var TasksListView = {};

  TasksListView.tasksListItemView = Marionette.ItemView.extend({
    template: TasksListItemTemplate,
    modelEvents: {
      change: "render",
      "enter:description": "render",
      selected: function () {
        //use this special event from the model to notify the list that the task should be selected
        this.trigger("selected:task");
      },
    },
    triggers: {
      click: "selected:task",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:dateUtc:short", date);
      },
    },
    selectItem: function () {
      this.$el.find(".review-item").addClass("selected-review-item");
    },
    deselectItem: function () {
      this.$el.find(".review-item").removeClass("selected-review-item");
    },
  });

  TasksListView.tasksListView = Marionette.CollectionView.extend({
    itemView: TasksListView.tasksListItemView,
    collectionEvents: {
      sort: "render",
    },
  });

  return TasksListView;
});
